import { Component, inject } from "@angular/core";
import { ExportBase } from "../export-base";
import { ExportType } from "@enums/ExportType";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/export/i18n/scope";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
    selector: "export-controls",
    templateUrl: "./export-controls.component.html",
    styleUrls: ["./export-controls.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [TranslatePipe, FormsModule, MatCheckboxModule]
})
export class ExportControlsComponent extends ExportBase {
    includearchivedlinks = true;
    permService = inject(PermissionsService);

    downloadControls(type: ExportType) {
        const extra = `includearchivedlinks=${this.includearchivedlinks}`;
        this.exportDataService.downloadExport(type, extra);
    }
}
